export default __webpack_public_path__ + "static/media/gold_reveal.c471283e.mp3";